import React, { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import Typography from "@mui/material/Typography";
import ApiHelper from "../../utillity/ApiHelper";
import APIURLConstants from "../../config/config";
import { useNavigate } from "react-router-dom";
import { useSiteState } from "../../hookState/SiteState";
import RouteConstants from "../../constants/RouteConstant";
import { setPlanState } from "../../hookState/PlanState";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export const CancelSubscription = () => {
	const state = useSiteState();
	let navigate = useNavigate();
	const [message, setMessage] = useState("");
	const [loading, setLoading] = useState(true);
	const [total, setTotal] = useState(50);
      const [open, setOpen] = React.useState(true);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = (event) => {
    setLoading(true);
    event.preventDefault();
    console.log(" provider",state.user.provider.get());
    
    const data = { id: state.user.provider.get() };

   ApiHelper.post(APIURLConstants.CANCEL_SUBSCRIPTION, data)
			.then((res) => {
                	setLoading(false);
                    if(res.data.success){
                     setOpen(false);
                     setMessage("Your subscription has been cancelled successfully.");
                    }
             
			})
			.catch((error) => {
				setLoading(false);
				console.log(error);
			});
  };

	
	const getProducts = () => {
		setLoading(true);
		const data = { user_id: state.user.id.get() };
		console.log(data);
		ApiHelper.post(APIURLConstants.GET_MY_PRODUCTS, data)
			.then((res) => {
                console.log("my products",res.data.result.products);
               if(res.data.result.products&&res.data.result.products.length>0 ){
                setTotal(50 - res.data.result.products.length);
               }
                
				setLoading(false);
				// setProducts(res.data.result.products);
				// setPlanState(res.data.result.products);
			})
			.catch((error) => {
				setLoading(false);
				console.log(error);
			});
	};

	useEffect(() => {
		if (state.user.get()) {
			getProducts();
		} else {
			navigate(RouteConstants.LOGIN);
		}
	}, []);

	
	return (
			<Box sx={{ background: "aliceblue",  height: "calc(100vh - 50px)"
}}>
			{loading ? (
				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						height: "100%",
						width: "100%",
						justifyContent: "center",
						alignContent: "center",
						alignItems: "center",
					}}
				>
					<CircularProgress
						sx={{
							color: "secondary.main",
						}}
					/>
				</Box>
			) : (
				<Box
					sx={{
						// p: 2,
						height: "100%",
						width: "100%",
						marginLeft: { xs: 0, md: 0 },
					}}
				>
					<Typography
						component="h1"
						variant="h5"
						alignContent={"flex-start"}
						fontWeight={600}
						padding={2}
					>
						Cancel Subscription
					</Typography>
                    {message!==""&& 
                     <Typography
						component="h1"
						variant="h5"
						alignContent={"flex-start"}
						fontWeight={600}
						padding={2}
					>
						{message}
					</Typography>}
                  
                    <Box sx={{display:'flex',flexDirection:'column',p:2}}>
                          <React.Fragment>
                   
                        <Dialog open={open} onClose={handleClose}>
                            <DialogTitle>Cancel Subscription</DialogTitle>
                            <DialogContent>
                            <DialogContentText>
                                {
                                 total===0?
                                 `Are you sure you want to cancel your subscription?`
                                 :
                                   `Are you sure you want to cancel your subscription? You still have ${total} unused credits remaining.`

                                //  products&&products.length>0 ? 
                                //       `Are you sure you want to cancel your subscription? You still have ${total} unused credits remaining.`
                                //     :
                                //     `Are you sure you want to cancel your subscription? You still have ${total} unused credits remaining.`
                                }
                             
                            </DialogContentText>
                            
                            </DialogContent>
                            <DialogActions>
                            <Button  sx={{color:'#000'}} onClick={handleClose}>Cancel</Button>
                            <Button sx={{color:'#000'}} onClick={handleSubmit} form="subscription-form">
                                Proceed
                            </Button>
                            </DialogActions>
                        </Dialog>
                        </React.Fragment>
                    </Box>
				
				</Box>
			)}
		
		</Box>
	);
};
